import { render, staticRenderFns } from "./HelperTaxaServico.vue?vue&type=template&id=66fad6f8&lang=pug"
import script from "./HelperTaxaServico.vue?vue&type=script&lang=js"
export * from "./HelperTaxaServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports